export const mixin = {
  data() {
    return {
      // 屏幕比例
      scaleBiLi : 1,
    };
  },
  methods: {
    // 富文本图片改路径
    updateImageUrl(val){
      let result = ''
      if (val) {
        result = val.replace(/\/prod-api/g,this.$store.getters.urlApi)
        result = result.replace(/\/dev-api/g,this.$store.getters.urlApi)
        return result
      }
    },
    // 富文本去掉所有标签
    removeLableAndImage(html) {
      let msg = html.replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, '\n')
        .replace(/<br\/?>/gi, '\n').replace(/<[^>/]+>/g, '')
        .replace(/(\n)?<\/([^>]+)>/g, '').replace(/\u00a0/g, ' ')
        .replace(/&nbsp;/g, ' ').replace(/<\/?(img)[^>]*>/gi, '')
        .replace(/&amp;/g, "&").replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&#39;/g, "\'")
        .replace(/&quot;/g, "\"")
        .replace(/<\/?.+?>/g, "")
      return msg
    },
    parseTime(time, pattern) {
      if (arguments.length === 0 || !time) {
        return null
      }
      const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
      let date
      if (typeof time === 'object') {
        date = time
      } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
          time = parseInt(time)
        } else if (typeof time === 'string') {
          time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
          time = time * 1000
        }
        date = new Date(time)
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
      }
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
        if (result.length > 0 && value < 10) {
          value = '0' + value
        }
        return value || 0
      })
      return time_str
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/index.js